// External Imports
import { useContext } from "react";
import { UtilityContext } from "../../context/util-context";
import { MdDirectionsCar } from "react-icons/md";

// Internal Imports
import ImageSelector from "./ImageSelector";

/** ========================================================================
 * * VehicleInformationCard Component
 * This component renders a card to display vehicle information.
 * ========================================================================== */

export default function VehicleInformationCard({
  label,
  name,
  secondary,
  image,
  loading,
  link,
}) {
  // Load Context
  const { navigate } = useContext(UtilityContext);

  /* ====================== CLICK HANDLER ====================== */
  const clickHandler = (e) => {
    if (link) navigate(link, e);
  };

  return (
    <div
      onClick={(e) => clickHandler(e)}
      className={`flex items-center space-x-4 ${link ? "clickable" : ""}`}
    >
      <ImageSelector
        image={image}
        loading={loading}
        classes="w-24 h-16 rounded-lg"
        imageClasses="object-contain w-24 h-16"
      >
        <MdDirectionsCar className="text-4xl text-yellow-600" />
      </ImageSelector>
      {loading ? (
        <div className="grid w-1/2 gap-2">
          <p className="h-4 rounded-sm bg-stone-700 animate-pulse" />
          <p className="h-4 rounded-sm bg-stone-700 animate-pulse" />
          <p className="h-4 rounded-sm bg-stone-700 animate-pulse" />
        </div>
      ) : (
        <div className="grid">
          <p className="font-semibold text-stone-400">{label}</p>
          <p className="text-base">{name}</p>
          <p className="text-stone-400">{secondary}</p>
        </div>
      )}
    </div>
  );
}
